import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../_common/button';

export default function Navigation({ handleApply, close, handleReset }) {
  return (
    <div
      className={
        'advanced-editor__navigation w-100 mt-auto mx-auto d-flex align-items-center justify-content-between'
      }>
      <Button
        type="button"
        className="btn btn-link reset"
        aria-label="Reset changes"
        onClick={handleReset}>
        Reset
      </Button>
      <Button
        type="button"
        className="btn btn-link cancel"
        aria-label="Cancel changes and close edit window"
        onClick={close}>
        Cancel
      </Button>
      <Button
        type="button"
        className="btn btn-primary apply"
        aria-label="Apply changes and close edit window"
        onClick={handleApply}>
        Apply
      </Button>
    </div>
  );
}

Navigation.propTypes = {
  handleApply: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
};
